import { inject, injectable } from 'inversify';

import { HttpService } from 'src/core/services/http.service';

@injectable()
export class TaxonomyService {
	constructor(
		@inject(HttpService)
		private httpService: HttpService
	) { }

	private baseUrl = 'api/v1/taxonomies';

	async getEntityTaxonomies(entityName: string): Promise<TaxonomicField[]> {
		const response = await this.httpService.get(`${this.baseUrl}/entity?entityName=${entityName}`);
		return response.data as TaxonomicField[];
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/shared/taxonomy.service.ts